<template>
  <DialogTemplateWithFooterToolkit
    ref="dialog"
    actions_class="mt-4"
    card_class="applicant-dialog"
    card_text_class="text-start px-0 inputs"
    :dialog.sync="applicantDialog"
    dialog_class="applicant-dialog"
    :first_col_class="true"
    :label="$t('Purchasing.Applicant')"
    @close="close">
    <div
      slot="activator"
      class="s-textarea__inner pointer flex align-center"
      style="min-height: 40px; height: 40px; border-radius: 31px;"
      @click="open">
      <UserIcon
        v-if="selected_applicants.length == 1"
        class="avatar mr-1"
        :name="typeof selected_applicants[0].fullName === 'string' ? selected_applicants[0].fullName : (typeof selected_applicants[0] === 'string' ? selected_applicants[0] : '')"
        size="22"
        :src="selected_applicants[0].avatar"/>
      {{ text }}
    </div>
    <sInput
      key="input-search"
      slot="actions"
      autofocus
      clearable
      :placeholder="$t('Common.EnterEmployeeName')"
      prefix-icon="search"
      :value.sync="search"
      @input="searchApplicant"/>
    <div
      slot="after_actions"
      class="letter-btns">
      <sButton
        v-for="letter in Object.keys(creator_groups)"
        :id="letter"
        :key="letter"
        class="letter-btn"
        :class="{
          'letter-btn_active': selectedLetter === letter
        }"
        small
        type="text"
        @click.prevent.stop="goTo(letter)">
        {{ letter }}
      </sButton>
    </div>
    <template #card_text>
      <div class="items">
        <template v-for="[letter, items] in Object.entries(creator_groups)">
          <div
            v-if="items && items.length > 0"
            :id="letter"
            :key="letter"
            class="letter-group">
            <ApplicantsDialogItem
              v-for="itemObject in items"
              :key="itemObject.id"
              :active="itemObject.active"
              :value="itemObject"
              @click="changeState(itemObject)">
              <sCheckbox
                :value="itemObject.active"
                @change="changeState(itemObject)"/>
            </ApplicantsDialogItem>
          </div>
        </template>
      </div>
    </template>
    <template
      v-if="selected_applicants && selected_applicants.length > 0"
      #first_col>
      <div
        class="flex align-center">
        <span>{{ $t('Purchasing.Selected') }}</span>
        <div
          v-if="selected_applicants.length == 1"
          class="pl-2">
          <PersonTooltip
            v-if="selected_applicants[0].fullName "
            :item="selected_applicants[0]"/>
          <span v-else>{{ selected_applicants[0] }}</span>
        </div>
        <sTooltip
          v-if="selected_applicants.length > 1">
          <div class="pl-2">
            {{ selected_applicants.length + ' ' + $tc('Purchasing.Applicants', selected_applicants.length) }}
          </div>
          <div slot="content">
            <ApplicantsDialogItem
              v-for="(selectedApplicant, n) in selected_applicants"
              :key="selectedApplicant.id || n"
              :value="selectedApplicant"/>
          </div>
        </sTooltip>
      </div>
    </template>
    <template #second_col>
      <div class="ml-auto">
        <sButton
          v-if="selected_applicants && selected_applicants.length > 0"
          class="mr-2"
          type="text"
          @click="selected_applicants = []">
          {{ $t('Common.Clear') }}
        </sButton>
        <sButton
          class-name="h7-text-medium"
          @click="apply">
          {{ $t(`Common.Apply`) }}
        </sButton>
      </div>
    </template>
  </DialogTemplateWithFooterToolkit>
</template>
<script>
import UserIcon from 'components/header/UserIcon.vue'
import TextField from 'components/common/inputs/TextField.vue'
import PersonTooltip from 'components/common/blocks/PersonTooltip.vue'
import DialogTemplateWithFooterToolkit from 'components/common/dialogs/DialogTemplateWithFooterToolkit.vue'

import ApplicantsDialogItem from 'components/purchasing/filters/ApplicantsDialogItem.vue'

import { applicationMixin, modalMixin } from 'mixins'

export default {
  name: 'applicantsDialog',
  mixins: [applicationMixin, modalMixin],
  data() {
    return {
      applicantDialog: false,
      selected_applicants: [],
      creators: [],
      filtred_creators: [],
      creator_groups: [],
      search: '',
      selectedLetter: null,
      users: [],
    }
  },
  props: {
    item: Object,
  },
  created() {
    this.getCreators()
  },
  computed: {
    text() {
      let text = this.selected_applicants.length > 1 ? this.selected_applicants.length + ' ' + this.$tc('Purchasing.Applicants', this.selected_applicants.length) :
        this.selected_applicants.length == 0 ? this.$t('Purchasing.All')
          : this.selected_applicants[0].secondName ?
            this.selected_applicants[0].secondName + '  ' + this.selected_applicants[0].firstName
            : this.selected_applicants[0].fullName || this.selected_applicants[0]
      return text
    },
  },
  methods: {
    changeState(item) {
      if (this.selected_applicants.includes(item)) {
        this.selected_applicants = this.selected_applicants.filter(el => el !== item)
      } else {
        this.selected_applicants.push(item)
      }
      item.active = !item.active
    },
    open() {
      setTimeout(() => {
        this.applicantDialog = true
        this.getCreators()
      }, 100)
    },
    async getCreators() {
      this.users = await this.$store.dispatch('getCreateOrdersUsers')
      this.users = this.users.map(item => {
        if (typeof item !== 'object') {
          return item
        }
        item.fullName = item.fullName?.trim()
        item.secondName = item.secondName?.trim()
        item.firstName = item.firstName?.trim()

        if (!item.fullName && (item.secondName || item.firstName)) {
          item.fullName = `${item.secondName ? item.secondName + ' ' : ''}${item.firstName ? item.firstName : ''}`
        }
        return item
      })
      this.users = this.$_.sortBy(this.users, 'fullName' )
      this.creator_groups = this.$_.groupBy(this.users, (item) => {
        item.active = this.selected_applicants.some(selected => (selected?.id || selected) == (item.id || item))
        if (typeof item === 'object' && item?.fullName?.charAt(0)) {
          return item.fullName.charAt(0).toUpperCase()
        }
        if (typeof item === 'string' && item.charAt(0)) {
          return item.charAt(0).toUpperCase()
        }
        return 'none'
      })
      this.filtred_creators = this.users
      this.creators = this.users
      this.selected_applicants = this.users.filter(el => this.item.search?.find(it => (it?.id || it) == el.id ))  || []
    },
    filterPersons(letter) {
      if (!this.creators) { return }
      return this.creator_groups[letter.toUpperCase()] || []
    },
    clear() {
      this.selected_applicants = []
      this.text = ''
      this.item.search = []
      this.$emit('toggleClear')
    },
    close() {
      this.applicantDialog = false
    },
    goTo(letter) {
      this.selectedLetter = letter === this.selectedLetter ? null : letter
      let current = document.getElementsByClassName('letter-btn_active')
      if (current[0]) { current[0].classList.remove('letter-btn_active') }
      let elem = document.querySelector(`.letter-group#${letter}`)
      elem.scrollIntoView()
    },
    apply() {
      this.item.search = this.selected_applicants.map(it => it?.id)
      this.$emit('toggleClear')
      this.applicantDialog = false
    },
    searchApplicant(text) {
      this.filtred_creators = this.creators.filter( item => item.firstName.toUpperCase().includes(text.toUpperCase())
        ||  item.middleName.toUpperCase().includes(text.toUpperCase())
        || item.secondName.toUpperCase().includes(text.toUpperCase())
        || item.fullName.toUpperCase().includes(text.toUpperCase()))
    }
  },
  watch: {
  },
  components: {
    UserIcon,
    TextField,
    PersonTooltip,
    ApplicantsDialogItem,
    DialogTemplateWithFooterToolkit
  }
}
</script>
<style lang="scss" scoped>
.applicant-dialog {
  padding : 56px 55px 0;
  max-width: 100%;
  max-height: 550px;
  .items {
    height: calc(70vh - 260px);
    overflow: auto;

  }
  .letter-btns {
    height: 66px;
    display: flex;
    align-items: center;
    padding-bottom: 8px;
    padding-top: 32px;
  }
  .letter-btn {
    height: 15px;
    border: none;
    padding: 0 2px;
    max-width: 15px;
    font-size: 11px;
    min-width: 48px;
    &::before {
      opacity: 0;
    }
    &_active {
      font-weight: 600;
      font-size: 24px;
      height: 24px;
    }
  }
}
</style>
